import axios from "axios";
import { urlApi, getApiUrl } from ".";
import { SecureStorage } from "@helpers/storage";
import { handleApiError } from "./errorHandler";

export function SendPaymentReceipt(idHistoric, email) {
    return new Promise((resolve, reject) => {
      SecureStorage.getItemAsync("TokenUser").then((token) => {
        let config = {
          method: "post",
          url: getApiUrl("/api/v1/Ticket/SendProof"),
          timeout: 3000,
          headers: {
            Authorization: "Bearer " + token,
            idHistoric: idHistoric,
            sameEmail: false,
            email: email,
          },
        };
  
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(handleApiError(error, "enviar comprovante"));
          });
      });
    });
  }
  
  export function PaymentHistoricByUser() {
    return new Promise((resolve, reject) => {
      SecureStorage.getItemAsync("TokenUser").then((token) => {
        var axios = require("axios");
        var config = {
          method: "get",
          url: getApiUrl(`/api/v1/Ticket/GetPaymentHistoric`),
          headers: {
            Authorization: "Bearer " + token,
          },
          timeout: 5000,
        };
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(handleApiError(error, "obter histórico de pagamentos"));
          });
      });
    });
  }